module.exports = __webpack_public_path__ + "static/media/eurogen.333765cb.svg";